import React from 'react';
import MermaidDiagram from '../common/MermaidDiagram';

const BlogContent = ({ content }) => {
  const renderContent = () => {
    // Split content by mermaid containers
    const parts = content.split(/<div class="mermaid-container"[^>]*>[\s\S]*?<\/div>/g);
    const mermaidMatches = content.match(/<div class="mermaid-container"[^>]*>([\s\S]*?)<\/div>/g) || [];
    
    const elements = [];
    
    for (let i = 0; i < parts.length; i++) {
      // Add regular HTML content
      if (parts[i].trim()) {
        elements.push(
          <div
            key={`content-${i}`}
            dangerouslySetInnerHTML={{ __html: parts[i] }}
          />
        );
      }
      
      // Add Mermaid diagram if there's a match
      if (mermaidMatches[i]) {
        const match = mermaidMatches[i];
        
        // Extract the style attributes
        const styleMatch = match.match(/style="([^"]*)"/);
        const style = styleMatch ? parseStyleString(styleMatch[1]) : {};
        
        // Extract the complete mermaid chart code (including init block)
        const mermaidMatch = match.match(/<div class="mermaid">\s*([\s\S]*?)\s*<\/div>/);
        
        if (mermaidMatch && mermaidMatch[1]) {
          let chartCode = mermaidMatch[1].trim();
          
          // Clean up the chart code while preserving essential formatting
          chartCode = chartCode
            .replace(/^\s+/gm, '    ') // Replace leading whitespace with 4 spaces for indentation
            .replace(/\s+$/gm, '') // Remove trailing whitespace
            .trim();
          
          elements.push(
            <div key={`mermaid-${i}`} style={style}>
              <MermaidDiagram chart={chartCode} />
              {/* Extract and render figure caption */}
              {(() => {
                const captionMatch = match.match(/<h4[^>]*>(.*?)<\/h4>/);
                const descriptionMatch = match.match(/<p[^>]*><em>(.*?)<\/em><\/p>/);
                
                return (
                  <div style={{ marginTop: '16px' }}>
                    {captionMatch && (
                      <h4 style={{ 
                        color: '#e5e7eb', 
                        fontSize: '1.25rem', 
                        fontWeight: '700', 
                        marginBottom: '12px',
                        textAlign: 'center'
                      }}>
                        {captionMatch[1]}
                      </h4>
                    )}
                    {descriptionMatch && (
                      <p style={{ 
                        color: '#d1d5db', 
                        lineHeight: '1.6', 
                        margin: '0',
                        textAlign: 'center',
                        fontStyle: 'italic'
                      }}>
                        <em dangerouslySetInnerHTML={{ __html: descriptionMatch[1] }} />
                      </p>
                    )}
                  </div>
                );
              })()}
            </div>
          );
        }
      }
    }
    
    return elements;
  };

  // Helper function to parse CSS style string into object
  const parseStyleString = (styleStr) => {
    const style = {};
    styleStr.split(';').forEach(rule => {
      const [property, value] = rule.split(':').map(s => s.trim());
      if (property && value) {
        // Convert kebab-case to camelCase
        const camelProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
        style[camelProperty] = value;
      }
    });
    return style;
  };

  return (
    <div className="text-gray-100 leading-relaxed space-y-6">
      {renderContent()}
    </div>
  );
};

export default BlogContent; 